import React, { PropTypes as T } from 'react';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();


export default class NotFound extends React.Component {
  static contextTypes = {
    router: T.object,
  }

  render() {
    return (
      <div className="page-centered">
        <div className="center-outer">
          <div className="center-inner">
            <div className="center-logo">
              <a href="/"><img src={theme.darkLogo.src} alt={theme.darkLogo.alt} /></a>
            </div>
            <div className="center-content">
              <h2 className="info">404 - Not Found</h2>
              <p className="info">We couldn&#8217;t find anything here, that&#8217;s all we know.</p>
              <div className="spacer" />
              <button className="large rose stretch" onClick={() => this.context.router.push('/')}><p>Go Home</p></button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/not-found-page/index.js
 **/